import React, { useEffect } from 'react';
import { Phone, X, History } from 'lucide-react';
import CallTracePanel from './CallTracePanel';
import AppendixWrapper from './common/AppendixWrapper';
import { useAppendix } from '../context/AppendixContext';

const CallTraceAppendix = ({ phones, onOpenWhatsAppConversation }) => {
    const { registerAppendix, closeAppendix } = useAppendix();
    const id = 'call-trace';

    useEffect(() => {
        registerAppendix(id, {
            title: 'Historial de Interacciones',
            icon: History
        });
    }, [registerAppendix]);

    const onClose = () => closeAppendix(id);

    return (
        <AppendixWrapper 
            id={id} 
            title="Historial de Interacciones" 
            icon={History} 
            className="w-full max-w-2xl"
            onClose={onClose}
            defaultPosition={{ x: (window.innerWidth - 700) / 2, y: 150 }}
        >
            {/* Content */}
            <div className="flex-1 overflow-hidden min-h-[400px] flex flex-col">
                <div className="flex-1 overflow-hidden">
                    <CallTracePanel phones={phones} isAppendix={true} onOpenWhatsAppConversation={onOpenWhatsAppConversation} />
                </div>
                {/* Bottom padding for safety */}
                <div className="h-6 bg-slate-950" />
            </div>
        </AppendixWrapper>
    );
};

export default CallTraceAppendix;
